module.exports = __webpack_public_path__ + "img/3.613c18ab.png";